import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

export const groupListingPropertySlice = createSlice({
  name: 'groupListingProperty',
  initialState,
  reducers: {
    updateGroupListingPropertySlice: (state, action) => {
      return {
        ...action.payload,
      };
    },
    clearGroupListingPropertySlice: () => {
      return initialState;
    }
  },
})

export const { updateGroupListingPropertySlice, clearGroupListingPropertySlice } = groupListingPropertySlice.actions

export default groupListingPropertySlice.reducer
